// 委外测试合同选择
import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, nullDate, getListIds } from '../../public/utility'
class EntrustedTestContractSelectDiv extends React.Component {
	state = {
		search: '',
		changedValues基本信息: {}
	}

	componentDidMount = () => {
		this.doGetEntrustedTestContractSelect()
	}

	doGetEntrustedTestContractSelect = (searchString = '') => {
		const { advanceExpenseID } = this.props
		const { changedValues基本信息 } = this.state
		Tyan.doPostEvent('GetEntrustedTestContractSelect', {
			data: {
				advanceExpenseID,
				changedValues基本信息,
				search: searchString
			},
			onEnd: ({ errorMessage, initValues基本信息, initValues委外测试合同, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					this.setState({ search: searchString, initValues基本信息, initValues委外测试合同, optionsParas })
				}
			}
		})
	}

	handlerSave = () => {
		const { advanceExpenseID, onClose, onSave } = this.props
		const { changedValues基本信息 } = this.state
		Tyan.doPostEvent('SaveEntrustedTestContractSelect', {
			data: {
				advanceExpenseID, changedValues基本信息
			},
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					onClose && onClose()
					onSave && onSave()
				}
			}
		})
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	fieldset基本信息 = () => {
		const { initValues委外测试合同 } = this.state
		return [
			{ _radio: '报告要求', minWidth: '95%', onChange: () => this.doGetEntrustedTestContractSelect(this.state.search) },
			{
				_checkgrid: '', name: '委外测试合同', rowNumbers: false, minRows: 13, maxRows: 13, margin: "5px 10px 5px 10px",
				itemsValues: initValues委外测试合同, onSearch: this.doGetEntrustedTestContractSelect,
				columns: [
					{ _text: '合同编号', minWidth: 150, flex: 1 },
					{ _text: '样品名称', minWidth: 150, flex: 1 },
					{ _text: '测试项目', minWidth: 150, flex: 1 },
					{ _text: '业务员', minWidth: 150, flex: 1 },
					{ _float: '委外金额', minWidth: 120, flex: 1 },
					{ _float: '合同金额', minWidth: 120, flex: 1 },
				],
			}]
	}

	render() {
		const { showMessage: Message, showBody: Body, bReadOnly, } = this.props
		const { errorMessage, initValues基本信息, changedValues基本信息 } = this.state
		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		return <Body data={this} maxWidth="1000"
			controls={
				[
					{ _button: '确定', icon: 'save', handler: this.handlerSave, disabled: !this.bChanged() },
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				]
			}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly, fullblock: true },
				]}
		/>
	}
}

export default connect()(EntrustedTestContractSelectDiv)